<template>
    <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">
      <vs-tab icon-pack="feather" icon="icon-user" :label="!isSmallerScreen ? '프로파일' : ''">
        <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
          <Profile />
        </div>
      </vs-tab>

      <vs-tab icon-pack="feather" icon="icon-clipboard" :label="!isSmallerScreen ? '포트폴리오' : ''">
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <!-- <Withdrawal /> -->
        </div>
      </vs-tab>

      <vs-tab icon-pack="feather" icon="icon-lock" :label="!isSmallerScreen ? '비밀번호 변경' : ''">
        <div class="tab-change-pwd md:ml-4 md:mt-0 mt-4 ml-0">
          <Password />
        </div>
      </vs-tab>

      <vs-tab icon-pack="feather" icon="icon-user-x" :label="!isSmallerScreen ? '탈퇴' : ''">
        <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
          <Withdrawal />
        </div>
      </vs-tab>
    </vs-tabs>
</template>

<script>
import Profile from "./Profile.vue"
import Password from "./Password.vue"
import Withdrawal from "./Withdrawal.vue"
// import Portfolio from "./Portfolio.vue"

export default {
    components: {
      Profile,
      Password,
      Withdrawal
    },

  data() {
    return {
      updateProfile:false,
      radios1:'user01',
      popupActive: false,
      // username: "johny_01",
      username: this.$store.state.AppActiveUser.displayName,
      email: this.$store.state.AppActiveUser.email,
      // company: "SnowMash Technologies Pvt Ltd",
    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    },
    isSmallerScreen() {
      return this.$store.state.windowWidth < 768
    }
  },
  methods:{
    successUpload(){
      this.$vs.notify({color:'success',title:'Upload Success',text:'Lorem ipsum dolor sit amet, consectetur'})
    },
    save () {
      this.$store.dispatch('auth/updateUsername', {'name':this.username, 'photo_url':this.activeUserInfo.photoURL})
      .then(()=>{
        this.updateProfile = false
        this.$vs.notify({
          color: 'success',
          title: '완료',
          text: '아바타를 변경하였습니다.'
        })
      }).catch(() => {
        this.updateProfile = false
        this.$vs.notify({
          color: 'danger',
          title: '실패',
          text: '관리자에게 문의 부탁 드립니다.'
        })
      })
    }
  }
}
</script>

<style>
      .btnall{
        width:80px;
        height:80px;
        position: relative;
        cursor: pointer;
        overflow: hidden;
        box-shadow: 2px 2px 8px 0px #000;
      }

      .btn {
         display:show;
         width:78px;
         height:78px;
         line-height:40px;
         margin:12px auto;
         z-index:1;
         overflow: hidden;
         text-align:center;
         cursor: pointer;
         -moz-border-radius: 50px;
         -webkit-border-radius: 50px;
         border-radius: 50px;

         transition:all 0.9s, color 0.3;
         }
         .btn:hover{color:#fff;}

         .hover1:hover {
          box-shadow:100px 0 0 0 rgba(0,0,0,0.2) inset;
          opacity: 0.8;
          }

       .btn2over {
          /* display:inline;
          line-height:40px;
          margin:15px auto;
          left: 50%;
          margin-top: 20px;
          margin-left: -70px;
          text-align:center;
          cursor: pointer;
          transition:all 0.9s, color 0.3; */
          display:show;
          padding:5px;
          color:#505050;
          line-height:40px;
          margin:15px auto;
          left: 50%;
          margin-top: -55px;
          margin-left: 20px;
          text-align:center;
          cursor: pointer;
          }
          .btn2over:hover{color:#000000;}

          .btn2none {
             /* display:inline;
             line-height:40px;
             margin:15px auto;
             left: 50%;
             margin-top: 20px;
             margin-left: -70px;
             text-align:center;
             cursor: pointer;
             transition:all 0.9s, color 0.3; */
             display:none;
             padding:5px;
             color:#000000;
             line-height:40px;
             margin:15px auto;
             left: 50%;
             margin-top: -70px;
             margin-left: -5px;
             text-align:center;
             cursor: pointer;
             }
             .btn2none:hover{color:#000000;}

             #btn > #btn2over {
             opacity: 0;
             transition: opacity 1s
             }

             #profile-tabs {
               .vs-tabs--content {
                 padding: 0;
               }
             }
</style>
